var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paxton-logo-spinner",
    width: 220,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @keyframes\n        loading-indicator-animation {\n        0%{\n        transform:translate3d(-134px,0,0);\n        }\n        75%{\n        transform:translate3d(150px,0,0);\n        }\n        100%{\n        transform:translate3d(150px,0,0);\n        }\n        }\n        #circle {\n        fill:#5AAB33;\n        animation:loading-indicator-animation 1.5s cubic-bezier(.10,.90,.90,.10) infinite both;\n        }\n    ")), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 6,
    cx: 81,
    cy: 10,
    style: {
      animationDelay: ".4s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 6,
    cx: 95,
    cy: 10,
    style: {
      animationDelay: ".3s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 6,
    cx: 109,
    cy: 10,
    style: {
      animationDelay: ".2s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 6,
    cx: 123,
    cy: 10,
    style: {
      animationDelay: ".1s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    r: 6,
    cx: 137,
    cy: 10,
    style: {
      animationDelay: "0s"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBubbles);
export default __webpack_public_path__ + "static/media/loading-bubbles.7f81f297ed773c45637194721808dc5c.svg";
export { ForwardRef as ReactComponent };